module.exports = __webpack_public_path__ + "img/logo.bc50419e.png";